import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../../utils/constants';
const BULLETS: string[] = ['Sin riesgo para vos', 'Reembolso del 100%', 'Sin preguntas', 'Se pide por email'];
export function Guarantee() {
  return <section className="bg-crema py-16 sm:py-20 px-5" data-id="element-148" data-mp="24ldhosw8k4og">
      <div className="max-w-4xl mx-auto rounded-3xl bg-white shadow-xl border border-dorado/30 p-7 sm:p-10 grid gap-8 md:grid-cols-[auto_1fr] md:items-center" data-id="element-149" data-mp="29eq898kh6lju">
        <div className="relative w-40 h-40 mx-auto flex items-center justify-center" data-id="element-150" data-mp="2jbulgiwcf6oi">
          <span className="absolute inset-0 rounded-full border-4 border-dashed border-dorado animate-spin-slow" aria-hidden="true" data-id="element-151" data-mp="2ob7h9t56zo38" />
          <div className="text-center px-6" data-id="element-152" data-mp="2sbzsgrxmk325">
            <ShieldCheckIcon className="w-9 h-9 text-dorado mx-auto" aria-hidden="true" data-id="element-153" data-mp="txg2kf80ae0x" />
            <p className="mt-1 font-serif text-sm font-bold text-violeta leading-tight" data-id="element-154" data-mp="xyrp2bvl2j4w">
              14 DÍAS DE GARANTÍA
            </p>
          </div>
        </div>

        <div data-id="element-155" data-mp="3smrgboj9kytq">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta leading-tight" data-id="element-156" data-mp="3sn9jz689afbo">
            Probalo 14 días. Si no te sirve, te devolvemos todo.
          </h2>
          <p className="mt-4 text-lg text-tinta/80 leading-relaxed" data-id="element-157" data-mp="3ivwqka6t7h3j">
            Hacés los primeros días con tu hijo y ves si algo cambia. Si no, escribís a{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-coral font-semibold underline" data-id="element-158" data-mp="ff6htnjuepy5">
              {SUPPORT_EMAIL}
            </a>{' '}
            y te devolvemos el dinero, sin preguntas.
          </p>
          <ul className="mt-6 grid gap-2 sm:grid-cols-2" data-id="element-159" data-mp="5ffk7czzjutu">
            {BULLETS.map(bullet => <li key={bullet} className="flex items-center gap-2 text-tinta/80" data-id="element-160" data-mp="guif953533a">
                <span className="w-1.5 h-1.5 rounded-full bg-dorado" aria-hidden="true" data-id="element-161" data-mp="2q77wuw832e1t" />
                {bullet}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}